import { render } from "./ValueYourTrade.vue?vue&type=template&id=65cef906&lang=true"
import script from "./ValueYourTrade.vue?vue&type=script&lang=js"
export * from "./ValueYourTrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/StartUpIcons/ValueYourTrade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65cef906"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65cef906', __exports__)) {
    api.reload('65cef906', __exports__)
  }
  
  module.hot.accept("./ValueYourTrade.vue?vue&type=template&id=65cef906&lang=true", () => {
    api.rerender('65cef906', render)
  })

}


export default __exports__